import { createAction } from 'typesafe-actions'

export const close = createAction('project/popup->CLOSE')()
export const setIsOpen = createAction('project/popup->SET_IS_OPEN')<boolean>()
export const setActiveSection = createAction('project/popup->SET_ACTIVE_SECTION')<number>()
